/**
 * A factory for a filter that capitalizes the input string.
 */
export function CapitalizeFilter() {
    return capitalize;

    /**
     * Capitalize the input string
     * @param {any} s The input string
     * @returns {any} The capitalized input string.
     */
    function capitalize(s) {
        if (!s || !s.toUpperCase || !s.slice) {
            return s;
        }
        return s[0].toUpperCase() + s.slice(1);
    }
}
